<template>
  <div class="serveManage">
    <ds-header title="活动报名列表"></ds-header>
    <a-form layout="inline">
      <a-form-item label="标题：">
        <a-input v-model.trim="searchForm.activityTitle" placeholder="请输入活动标题" class="inputClass" />
      </a-form-item>
      <a-form-item label="活动方式：">
        <a-select default-value="" v-model="searchForm.activityWay" style="width: 200px">
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="1"> 线下活动 </a-select-option>
          <a-select-option value="2"> 商业活动 </a-select-option>
          <a-select-option value="3"> 线上活动 </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="状态：">
        <a-select default-value="" v-model="searchForm.activityStatus" style="width: 200px">
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 禁用 </a-select-option>
          <a-select-option value="1"> 启用 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="活动时间：">
        <a-range-picker show-time v-model="searchForm.activityTime"> </a-range-picker>
      </a-form-item>
      <a-form-item label="可见项目">
        <a-tree-select
          v-model="searchForm.projectIds"
          style="width: 200px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="请选择所属项目"
          allow-clear
          multiple
          tree-default-expand-all
        >
          <a-tree-select-node
            :disabled="item.disabled"
            :value="item.id"
            :title="item.project_name"
            v-for="item in projectList"
            :key="item.id"
          >
            <a-tree-select-node :key="arr.id" :value="arr.id" :title="arr.project_name" v-for="arr in item.child">
            </a-tree-select-node>
          </a-tree-select-node>
        </a-tree-select>
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px"> <a-icon type="search" />查询 </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>
    <div style="padding-top: 15px">
      <a-button type="primary" @click="addActivity()"> <a-icon type="plus" /> 新建活动</a-button>
    </div>
    <div style="padding-top: 15px">
      <a-table
        :rowKey="(record, index) => index"
        :columns="table.columns"
        :data-source="table.dataInfo"
        :pagination="table.pagination.total ? table.pagination : false"
        @change="pageChange"
        bordered
        :scroll="{ x: 1500 }"
      >
        <span slot="projectList" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.projectList }}</template>
            <span class="field">{{ record.projectList }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record" class="action">
          <a-button class="btnClass" type="link" @click="view(record)"> 查看 </a-button>
          <a-button class="btnClass" type="link" @click="edit(record)" v-show="record.activityState === 0">
            编辑
          </a-button>
          <a-button
            class="btnClass"
            type="link"
            @click="userScanCode(record)"
            v-if="
              record.verifyType === 1 &&
              record.showPlatform == 0 &&
              record.whetherOff == 1 &&
              record.whetherRegistration == 1
            "
          >
            用户主扫二维码
          </a-button>
          <a-button
            class="btnClass"
            type="link"
            @click="startUsingAndEnable(record.id, 0)"
            v-if="record.activityState === 1"
            >禁用
          </a-button>
          <a-button
            class="btnClass"
            type="link"
            @click="startUsingAndEnable(record.id, 1)"
            v-if="record.activityState === 0"
          >
            启用
          </a-button>
          <a-button class="btnClass" type="link" @click="deleteActivityById(record)"> 删除 </a-button>
          <a-button class="btnClass" type="link" @click="showActivityQrCode(record)">活动二维码</a-button>
          <a-button
            v-show="record.whetherRegistration === 1"
            class="btnClass"
            type="link"
            @click="adjustTheNumberOfApplicants(record)"
          >
            调整报名人数
          </a-button>
        </span>
        <span slot="export" slot-scope="text, record" class="export">
          <a-button v-show="record.showRegisterUserButtonStatus" class="btnClass" type="link" @click="showUserApplyManage(record)">用户报名管理</a-button>
        </span>
      </a-table>
    </div>
    <a-modal v-model="isShowQrcode" title="主扫二维码" :footer="null">
      <div class="qrCodeClass">
        <div id="qrcode" ref="qrcode"></div>
        <div style="margin-top: 15px">
          <a-button type="primary" @click="downLoadCode">下载</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="visibleActivityQrCode" width="30%" title="活动二维码" :footer="null">
      <div class="qrCodeClass">
        <div class="codeItem">
          <div class="codeTitle">扫码报名（i友APP&小程序）</div>
          <div id="activityQrcode" ref="activityQrcode"></div>
          <div style="margin-top: 15px">
            <a-button type="primary" @click="downLoadActivityQrCode('activityQrcode')">下载</a-button>
          </div>
        </div>
        <!--        <div class="codeItem">-->
        <!--          <div class="codeTitle">-->
        <!--            微信-->
        <!--          </div>-->
        <!--          <div id="wxQrcode" ref="wxQrcode"></div>-->
        <!--          <div style="margin-top: 15px">-->
        <!--            <a-button type="primary" @click="downLoadActivityQrCode('wxQrcode')">下载</a-button>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </a-modal>
    <a-modal
      title="调整报名人数"
      :visible="visibleAdjustApplicants"
      :confirm-loading="adjustApplicantsLoading"
      destroyOnClose
      @ok="handleConfirmAdjustApplicants"
      @cancel="handleCancelAdjustApplicants"
      width="800px"
    >
      <a-form-model
        ref="adjustApplicantsForm"
        :model="adjustApplicantsForm"
        :rules="adjustApplicantsRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="right"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="实际报名成功人数">
              {{ adjustApplicantsForm.actualSuccessCount }}
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="活动总人数限制">
              {{ adjustApplicantsForm.totalLimitText }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :labelCol="{ span: 3, offset: 2 }" label="调整值" prop="registrationBasePersonSize">
              <a-input-number
                v-model="adjustApplicantsForm.registrationBasePersonSize"
                :style="{ width: '360px' }"
                :precision="0"
                :min="0"
                :max="9999"
                placeholder="请输入"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div :style="{ color: 'red', paddingLeft: '112px', lineHeight: '22px' }">
          注：<br />
          1、用户端展示数量 = 最新【调整值】 +【实际报名成功人数】<br />
          2、仅支持输入正整数，且调整后报名成功用户总和不能超出活动总人数限制<br />
          3、若下调活动总人数限制，【调整值】将自动重置为零，需手动重新调整
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ConfirmBoxModule from '@/components/confirmBoxModule';
import DSTable from '@/components/DSComponents/DSTable';
import {
  getActivityList,
  toStartUsingAndEnable,
  removeActivityById,
  getProjects,
  getAppliedUserInfoByActivityIdAndPhoneNumber,
  adjustActivityNumber,
  getActivityNumberLimit,
} from '@/api/activityRegistration';
import moment from 'moment';
import QRCode from 'qrcodejs2';
import BlacklistOperationForm from '@/views/activityRegistration/blacklistManagement/components/BlacklistOperationForm.vue';
import { isvalidPhone } from '@/utils/validate';
export default {
  name: 'activityRegistration',
  components: {
    BlacklistOperationForm,
    DSTable,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.load.loading,
      projectList: (state) => {
        return (
          state.common.projects.length &&
          state.common.projects.map((item) => {
            return {
              ...item,
              disabled: !!item.child,
            };
          })
        );
      },
    }),
  },
  data() {
    return {
      // 是否展示活动报名二维码
      visibleActivityQrCode: false,
      // 调整报名人数弹窗loading
      adjustApplicantsLoading: false,
      // 调整报名人数弹窗
      visibleAdjustApplicants: false,
      // 当前活动已经报名的用户
      appliedUserInfo: [],
      dateFormat: 'YYYY/MM/DD',
      labelCol: { span: 10 },
      wrapperCol: { span: 8 },
      // 调整报名人数form
      adjustApplicantsForm: {
        activityId: '',
        actualSuccessCount: 0,
        totalLimit: 0,
        totalLimitText: '-',
        registrationBasePersonSize: undefined,
      },
      adjustApplicantsRules: {
        registrationBasePersonSize: [
          { required: true, message: '请输入调整值', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请输入调整值'));
                return;
              }
              if (!Number.isInteger(value) || value < 0) {
                callback(new Error('仅支持输入正整数'));
                return;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
      // 检索
      searchForm: {
        // 活动标题
        activityTitle: '',
        // 活动方式
        activityWay: '',
        // 活动状态
        activityStatus: '',
        // 活动时间
        activityTime: [],
        // 活动可见项目
        projectIds: undefined,
      },
      // 是否展示二维码
      isShowQrcode: false,
      title: '',
      id: '',
      table: {
        dataInfo: [],
        columns: [
          {
            title: '活动id',
            dataIndex: 'id',
            key: 'id',
            width: '200px',
          },
          {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            width: '200px',
          },
          {
            title: '状态',
            dataIndex: 'activityState',
            customRender: (text) => {
              if (text === 1) {
                return '启用';
              } else if (text === 0) {
                return '禁用';
              }
            },
            width: '100px',
          },
          {
            title: '活动方式',
            dataIndex: 'activityMode',
            customRender: (text) => {
              if (text === 1) {
                return '线下活动';
              } else if (text === 2) {
                return '商业活动';
              } else if (text === 3) {
                return '线上活动';
              } else {
                return '-';
              }
            },
            width: '100px',
          },
          {
            title: '报名人数',
            dataIndex: 'number',
            key: 'number',
            width: '100px',
            customRender: (text, record, index) => {
              return `${text}(${record.registrationBasePersonSize})`;
            },
          },
          {
            title: '核销人数',
            dataIndex: 'writeOffNumber',
            key: 'writeOffNumber',
            width: '100px',
          },
          {
            title: '可见项目',
            dataIndex: 'projectList',
            key: 'projectList',
            width: '200px',
            scopedSlots: { customRender: 'projectList' },
          },
          {
            title: '活动时间',
            dataIndex: 'gmtCreate',
            customRender(text, record, index) {
              return record.startTime + '～' + record.endTime;
            },
            width: '200px',
          },
          {
            title: '链接地址（报名详情页）',
            dataIndex: 'activityUrl',
            key: 'activityUrl',
            width: '300px',
          },
          {
            title: '更新时间',
            dataIndex: 'gmtModified',
            key: 'gmtModified',
            customRender(text) {
              return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-';
            },
            width: '200px',
          },
          {
            title: '是否验证参与',
            dataIndex: 'whetherOff',
            customRender(text) {
              if (text === 1) {
                return '是';
              } else {
                return '否';
              }
            },
            width: '150px',
          },
          {
            title: '验证方式',
            dataIndex: 'verifyType',
            customRender(text, record) {
              if (record.whetherRegistration === 0 || record.whetherOff === 0) {
                return '-';
              } else {
                if (text === 1) {
                  return '用户主扫';
                } else {
                  return '用户被扫';
                }
              }
            },
            width: '100px',
          },
          {
            title: '操作',
            key: 'action',
            width: '200px',
            className: 'action-ql-list',
            scopedSlots: { customRender: 'action' },
            fixed: 'right',
          },
          {
            title: '数据导出',
            className: 'action-ql-list',
            width: '200px',
            scopedSlots: { customRender: 'export' },
            fixed: 'right',
          },
        ],
        //分页数据
        pagination: {
          showSizeChanger: true,
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showTotal: (total) => {
            return `共 ${total} 条`;
          },
        },
      },
    };
  },
  mounted() {
    this.searchFormList();
    let handleResize = () => {
      let width = document.getElementsByClassName('serveManage')[0].clientWidth;
      console.log(width, '=====');
      if (width > 2150) {
        this.table.columns[this.table.columns.length - 2].fixed = '';
        this.table.columns[this.table.columns.length - 1].fixed = '';
      } else {
        this.table.columns[this.table.columns.length - 2].fixed = 'right';
        this.table.columns[this.table.columns.length - 1].fixed = 'right';
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
  },
  methods: {
    handleSearch(value) {
      if (!value || value.length !== 11) return;
      this.cancelApplyForm.activityUserInfoId = '';
      this.getAppliedUserInfo(this.cancelApplyForm.activityId, value);
    },
    handleChange(val) {
      console.log(val);
      const appliedUserItem =
        this.appliedUserInfo.length && this.appliedUserInfo.find((item) => item.activityUserInfoId === val);
      this.cancelApplyForm.mobile = appliedUserItem && appliedUserItem.mobile;
    },
    /**
     * @Description：查询报名用户通过活动id和用户手机号
     * @Author cxd
     * @Date 2026/1/6 18:51
     */
    async getAppliedUserInfo(activityId, phoneNumber) {
      const res = await getAppliedUserInfoByActivityIdAndPhoneNumber(activityId, phoneNumber);
      const { code, data, msg } = res;
      if (code === '200' || code === 200) {
        this.appliedUserInfo =
          (data &&
            data.length &&
            data.map((item) => {
              return {
                ...item,
                value: `${item.mobile} - ${item.nickname} - ${item.gmtCreate}`,
              };
            })) ||
          [];
        if (res.data && res.data.length === 0) {
          this.$message.warning('未查询到该用户报名信息！');
        }
      } else {
        this.$message.error(msg);
      }
    },
    // 新建活动
    addActivity() {
      this.$router.push({
        path: '/activityRegistration/add',
        query: {
          type: 'add',
        },
      });
    },
    // 处理接口参数
    searchFormList() {
      let data = {
        // 活动标题
        activityTitle: this.searchForm.activityTitle,
        // 活动方式
        activityWay: this.searchForm.activityWay,
        // 活动状态
        activityStatus: this.searchForm.activityStatus,
        // 活动时间
        activityStart:
          this.searchForm.activityTime.length === 0
            ? ''
            : moment(this.searchForm.activityTime[0]).format('YYYY-MM-DD HH:mm:ss'),
        activityEnd:
          this.searchForm.activityTime.length === 0
            ? ''
            : moment(this.searchForm.activityTime[1]).format('YYYY-MM-DD HH:mm:ss'),
        // 活动可见项目
        projectIds: this.searchForm.projectIds,
      };
      this.getList(this.table.pagination.pageSize, this.table.pagination.current, data);
    },

    // 查看
    view(record) {
      let id = record.id;
      this.$router.push({
        path: '/activityRegistration/add',
        query: {
          id: id,
          type: 'view',
        },
      });
    },

    // 获取列表
    async getList(size, page, data) {
      const res = await getActivityList(size, page, data);
      if (res.code === '200') {
        this.table.pagination.total = res.data.total;

        this.table.dataInfo =
          res.data.items &&
          res.data.items.length &&
          res.data.items.map((item) => {
            return {
              ...item,
              projectList:
                (item.projectList &&
                  item.projectList.length &&
                  item.projectList
                    .map((projectItem) => {
                      return projectItem.projectName;
                    })
                    .join(',')) ||
                '-',
            };
          });
      }
    },

    //查询
    search() {
      this.table.pagination.current = 1;
      this.searchFormList();
    },

    //重置
    resetSearchForm() {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.searchForm.activityTitle = '';
      this.searchForm.activityWay = '';
      this.searchForm.activityStatus = '';
      this.searchForm.activityTime = '';
      this.searchForm.projectIds = [];
      this.searchFormList();
    },

    //编辑
    edit(record) {
      this.id = record.id;
      this.$router.push({
        path: '/activityRegistration/add',
        query: {
          id: this.id,
          type: 'edit',
        },
      });
    },
    // 展示二维码
    userScanCode(data) {
      this.isShowQrcode = true;
      let code = {
        scanType: 'share',
        scanValue: `${
          process.env.NODE_ENV === 'production'
            ? 'https://yuanqu.innoecos.cn/apps/appcv/registrationConfirm?id=' + data.id
            : 'https://yuanqu-sit.innoecos.cn/apps/appcv/registrationConfirm?id=' + data.id
        }`,
      };
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
        new QRCode(this.$refs.qrcode, {
          width: 200, // 二维码宽度，单位像素
          height: 200, // 二维码高度，单位像素
          text: JSON.stringify(code), // 生成二维码的链接
          correctLevel: QRCode.CorrectLevel.H,
        });
      }, 100);
    },
    /**
     * 展示活动详情二维码
     */
    showActivityQrCode(row) {
      this.visibleActivityQrCode = true;
      const { activityUrl, id } = row;
      let code = activityUrl;
      let wxCode = '';
      if (process.env.NODE_ENV === 'production') {
        wxCode = `https://yuanqu.innoecos.cn/apps/appcv/activityShare?id=${id}&isAndroid=iOS&version=iOS&form=App`;
      } else {
        wxCode = `https://yuanqu-sit.innoecos.cn/apps/appcv/activityShare?id=${id}&isAndroid=iOS&version=iOS&form=App`;
      }
      setTimeout(() => {
        this.$refs.activityQrcode.innerHTML = '';
        new QRCode(this.$refs.activityQrcode, {
          width: 200, // 二维码宽度，单位像素
          height: 200, // 二维码高度，单位像素
          text: code, // 生成二维码的链接
          correctLevel: QRCode.CorrectLevel.H,
        });
      }, 100);
      // setTimeout (()=> {
      //   this.$refs.wxQrcode.innerHTML = ''
      //   new QRCode(this.$refs.wxQrcode, {
      //     width: 200, // 二维码宽度，单位像素
      //     height: 200, // 二维码高度，单位像素
      //     text: wxCode, // 生成二维码的链接
      //     correctLevel: QRCode.CorrectLevel.H
      //   })
      // },100)
    },

    /**
     * @Description：展示用户报名管理
     * @Author cxd
     * @Date 2026/1/6 17:54
     */
    async showUserApplyManage(row) {
      await this.$router.push({
        path: '/activityRegistration/userRegistrationManagement',
        query: {
          // 活动id
          id: row.id,
          // 活动标题
          title: row.title,
          // 是否展示导出签名协议
          showExportSign: row.exportProtocolFileButtonShowState,
          // 活动是否需要核销
          isVerification: row.needWriteOff,
          // 活动是否需要审核
          isReview: row.auditRequired,
        },
      });
    },

    //分页操作
    pageChange(option) {
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.searchFormList();
    },
    // 禁用启用
    startUsingAndEnable(id, status) {
      let that = this;
      this.$confirm({
        title: `确定要${status === 1 ? '启用' : '禁用'}该活动吗？`,
        onOk() {
          toStartUsingAndEnable(id, status).then((res) => {
            if (res.code === '200') {
              that.$message.success('操作成功');
              that.searchFormList();
            } else {
              that.$message.error('操作失败');
            }
          });
        },
        onCancel() {},
      });
    },
    // 删除活动
    deleteActivityById(data) {
      let that = this;
      if (data.activityStatu === 1) {
        this.$message.warning('活动正在启用状态，禁止删除！');
        return;
      }
      this.$confirm({
        title: `确定要删除该活动吗？`,
        onOk() {
          removeActivityById(data.id).then((res) => {
            if (res.code === '200') {
              that.$message.success('操作成功');
              that.searchFormList();
            } else {
              that.$message.error('操作失败');
            }
          });
        },
        onCancel() {},
      });
    },
    /**
     * @Description: 调整报名人数
     * @Author: cxd
     * @Date: 2026/3/24 14:42
     */
    adjustTheNumberOfApplicants(row) {
      const params = {
        activityId: row.id,
      };
      // 获取调整人数的限制
      getActivityNumberLimit(params).then((res) => {
        const { code, data, msg } = res;
        if (code === '200') {
          // 实际报名人数
          const actualSuccessCount = Number(data.registeredCount || 0);
          // 活动人数上限
          const totalLimit = Number(data.peopleNumber || 0);
          const isUnlimited = !Number.isFinite(totalLimit) || totalLimit <= 0;
          this.adjustApplicantsForm = {
            activityId: row.id,
            actualSuccessCount,
            totalLimit,
            totalLimitText: isUnlimited ? '无限制' : totalLimit,
            registrationBasePersonSize: undefined,
          };
          this.visibleAdjustApplicants = true;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 调整报名人数-取消
    handleCancelAdjustApplicants() {
      this.visibleAdjustApplicants = false;
      this.adjustApplicantsLoading = false;
    },
    // 调整报名人数-确认
    handleConfirmAdjustApplicants() {
      this.$refs.adjustApplicantsForm.validate(async (valid) => {
        if (!valid) return;
        const { totalLimit, totalLimitText, registrationBasePersonSize, actualSuccessCount } =
          this.adjustApplicantsForm;
        const isUnlimited = totalLimitText === '无限制';
        if (!isUnlimited && registrationBasePersonSize + actualSuccessCount > totalLimit) {
          this.$message.warning('调整后报名成功用户总和不能超出活动总人数限制');
          return;
        }
        // TODO
        const res = await adjustActivityNumber(this.adjustApplicantsForm);
        const { code, msg } = res;
        if (code === '200') {
          this.$message.success('调整成功');
          this.visibleAdjustApplicants = false;
          this.searchFormList();
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 下载二维码
    downLoadCode() {
      //找到canvas标签
      const myCanvas = document.getElementById('qrcode').getElementsByTagName('canvas');
      //创建一个a标签节点
      const a = document.createElement('a');
      //设置a标签的href属性（将canvas变成png图片）
      a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream');
      //设置下载文件的名字
      a.download = '核销码.png';
      //点击
      a.click();
    },

    /**
     * 活动二维码下载
     */
    downLoadActivityQrCode(refCode) {
      //找到canvas标签
      const myCanvas = document.getElementById(refCode).getElementsByTagName('canvas');
      //创建一个a标签节点
      const a = document.createElement('a');
      //设置a标签的href属性（将canvas变成png图片）
      a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream');
      //设置下载文件的名字
      a.download = `活动${refCode === 'activityQrcode' ? 'i友' : '微信'}二维码.png`;
      //点击
      a.click();
    }
  },
};
</script>

<style lang="scss" scoped>
.btnClass {
  padding: 0px;
  padding-right: 5px;
}
.footerButton {
  margin-top: 10px;
  margin-right: 10px;
}
.action a {
  color: #1890ff;
  margin-right: 15px;
}
.action a:hover {
  color: #40a9ff;
}
.field {
  font-size: 12px;
  display: inline-block;
  height: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}
.inputClass {
  width: 200px;
}
.inputColor {
  color: #bdbdbd !important;
}
.qrCodeClass {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .codeItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .codeTitle {
      margin-bottom: 15px;
      font-weight: 600;
    }
  }
}
</style>
